// extracted by mini-css-extract-plugin
export default {"eventItem":"Event_eventItem__cBfwi","title":"Event_title__Kekdd","textContent":"Event_textContent__E379u"};